document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.product-card-slider');
  sliders.forEach(slider => {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: false,
      loop: true,
    });
  });
});